import {Picture} from '@core/services/picture';


const functionariesPlaceholderImage = 'assets/icons/gentleman-filled-grey.png';

class FunctionaryFunction {
  functionName: string;
  uiFunction: string;
  start: number;

  public constructor(init?: Partial<FunctionaryFunction>) {
    if (init['function'] != null) {
      this.functionName = init['function'];
    }
    delete init['function'];

    Object.assign(this, init);
  }

  public getNameOfFunction(strict: boolean = true): string {
    if (strict) {
      return this.uiFunction;
    }
    return this.uiFunction || this.functionName;
  }
}

export class Functionary {
  id: number;

  title: string;
  firstname: string;
  lastname: string;
  email: string;
  landline: string;
  mobile_phone: string;

  functions: FunctionaryFunction[];
  group: string;

  pictures: Picture[];
  images: {};


  public constructor(init?: Partial<Functionary>) {
    this.functions = [];
    let functionsJson = [];
    if (init.functions) {
      functionsJson = JSON.parse(JSON.stringify(init.functions));
    }
    init.functions = [];

    this.pictures = [];
    // copy JSON, else it's doubled
    let picturesJson = [];
    if (init.pictures) {
      picturesJson = JSON.parse(JSON.stringify(init.pictures));
    }
    init.pictures = [];

    Object.assign(this, init);

    functionsJson.forEach(funJson => {
      const functionInfo = new FunctionaryFunction(funJson);
      this.functions.push(functionInfo);
    });

    picturesJson.forEach(pictureJson => {
      const picture = new Picture(pictureJson);
      this.pictures.push(picture);
    });
    this.images = {};
  }

  public getImageUrl(size: string) {
    return Picture.getImageOfSizeByString(this.pictures, size, 'face', functionariesPlaceholderImage);
  }

  public getFullName() {
    let name = '';
    if (this.title != null) {
      name += this.title;
    }
    if (this.firstname != null) {
      if (name.length !== 0) {
        name += ' ';
      }
      name += this.firstname;
    }
    if (this.lastname != null) {
      if (name.length !== 0) {
        name += ' ';
      }
      name += this.lastname;
    }

    return name;
  }
}
